import { useEffect, useRef } from 'react';

import { helper } from '@myrealtrip/frontend-weblog';

const { sendPageViewLog } = helper;

export default function usePageViewLog(
  log: Record<string, unknown> | null,
  onLog = sendPageViewLog,
) {
  const sentLog = useRef(false);

  useEffect(() => {
    if (!log) {
      return;
    }

    if (!sentLog.current) {
      onLog(log);
      sentLog.current = true;
    }
  }, [log, onLog]);
}
